(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exportFn(
            require('../../../enums/metrics.js').dataType,
            require('../../../enums/metrics.js').collection,
            require('../../../enums/metrics.js').sources,
            require('../../../enums/metrics.js').sourceDetails,
            require('../enums/dataSourceFilterGroupIds.js')
        );

    } else {
        RivalIQ.module('metrics.new.dataSources', function (dataSources) {
            dataSources.YoutubePublicPost = exportFn(
                RivalIQ.enums.dataType,
                RivalIQ.enums.collection,
                RivalIQ.enums.sources,
                RivalIQ.enums.sourceDetails,
                RivalIQ.metrics.new.enums.DataSourceFilterGroupIds
            );
        });
    }

    function exportFn(dataType, collection, sources, sourceDetails, DataSourceFilterGroupIds) {
        return {
            name: 'YouTube public post data',
            channelName: sourceDetails[sources.YOUTUBE].name,
            postName: sourceDetails[sources.YOUTUBE].postName,

            storageDimensions: [
                'postId'
            ],

            availableDimensions: [
                'companyId',
                'companySetId',
                'day', 'week', 'month',
                'dayOfWeek', 'hourOfDay',
                'mediaType',
                'engagementType',
                'postTagId',
                'hashtag',
                'keyword'
            ],

            fields: {
                postId: {
                    dataType: dataType.STRING
                },
                native_id: {
                    dataType: dataType.STRING
                },
                companyId: {
                    dataType: dataType.STRING
                },
                companyName: {
                    dataType: dataType.STRING
                },
                published_at: {
                    name: 'Published At',
                    collection: collection.GENERAL,
                    dataType: dataType.DATE
                },
                engagement_total: {
                    name: 'Engagement Total',
                    colection: collection.ENGAGEMENTS,
                    dataType: dataType.INTEGER
                },
                applause: {
                    name: 'Likes',
                    collection: collection.ENGAGEMENT_DETAILS,
                    dataType: dataType.INTEGER
                },
                conversation: {
                    name: 'Comments, Lifetime',
                    collection: collection.ENGAGEMENT_DETAILS,
                    dataType: dataType.INTEGER
                },
                presence_reach: {
                    name: 'Subscribers',
                    collection: collection.AUDIENCE,
                    dataType: dataType.INTEGER
                },
                engagement_rate_by_presence_reach: {
                    name: 'Engagement Rate by Follower',
                    collection: collection.ENGAGEMENT,
                    dataType: dataType.NUMERIC
                },
                has_hashtags: {
                    // 1 if this post has any hashtags, 0 otherwise.
                    dataType: dataType.INTEGER
                },
                engagement_rate_by_presence_reach_lift: {
                    name: 'Engagement Rate Lift',
                    collection: collection.ENGAGEMENT,
                    dataType: dataType.NUMERIC
                },
                other_posts_engagement_rate_by_presence_reach: {
                    name: 'Engagement Rate by Follower w/o tag',
                    collection: collection.ENGAGEMENT,
                    dataType: dataType.NUMERIC
                },
                video_views: {
                    name: 'Views',
                    collection: collection.VIDEO_VIEWS_DETAILS,
                    dataType: dataType.INTEGER
                },
                message: {
                    name: 'Message',
                    collection: collection.GENERAL,
                    dataType: dataType.STRING
                },
                postLink: {
                    name: 'Post Link',
                    dataType: dataType.STRING
                },
                mediaType: {
                    name: 'Type',
                    dataType: dataType.STRING
                },
                link: {
                    dataType: dataType.STRING
                },
                canonicalUrl: {
                    dataType: dataType.STRING
                },
                linkTitle: {
                    name: 'Link Title',
                    dataType: dataType.STRING
                },
                postedTitle: {
                    name: 'Posted Title',
                    dataType: dataType.STRING
                },
                captured_at: {
                    name: 'Captured At',
                    dataType: dataType.DATE
                },
                platformImageUrl: {
                    dataType: dataType.STRING
                },
                imageUrl: {
                    dataType: dataType.STRING
                },
                linkDescription: {
                    name: 'Link Description',
                    dataType: dataType.STRING
                },
                presence_icon_url: {
                    dataType: dataType.STRING
                },
                presence_handle: {
                    name: 'Presence Handle',
                    dataType: dataType.STRING
                },
                source: {
                    dataType: dataType.INTEGER
                },
                engagement_rate_by_view: {
                    name: 'Engagement Rate by View',
                    collection: collection.ENGAGEMENT,
                    dataType: dataType.NUMERIC
                },
                estimated_impressions: {
                    name: 'Estimated Impressions',
                    collection: collection.GENERAL,
                    dataType: dataType.NUMERIC
                },
                engagement_rate_by_estimated_impression: {
                    name: 'Engagement Rate by Estimated Impression',
                    collection: collection.GENERAL,
                    dataType: dataType.NUMERIC
                }
            },

            supportedFilterGroups: [
                DataSourceFilterGroupIds.company,
                DataSourceFilterGroupIds.timePeriod,
                DataSourceFilterGroupIds.source,
                DataSourceFilterGroupIds.publicPost,
                DataSourceFilterGroupIds.ordering
            ]
        };
    }
})();
